var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-filters"},_vm._l((_vm.tableHeaders),function(header){return _c('rn-field',{key:header.name,attrs:{"input-props":{
			id: header.name,
			options: header.options && !!header.options.length ? _vm.getHeaderOptions(header.options, header.name) : [],
			type: _vm.getFieldType(header),
			format: _vm.getFieldType(header) === 'datetime' && 'dateRange',
			placeholder: _vm.getTranslation(header.name),
			initialValues: _vm.getActiveValues(header.name),
		}},on:{"update:value":function (values) { return _vm.updateFilter(header.name, values); }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }